function getCookie(name) {
    let cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        if (name == cookiePair[0].trim()) {
            // Decoding the cookie value and return
            return decodeURIComponent(cookiePair[1]);
        }
    }
    // Return null if not found
    return null;
}

function cartDeliveryDetails() {
    if (getCookie("delivery_expires_time")) {
        // Set order attributes.
        document.querySelector("input[name='attributes[delivery_date]']").value = getCookie('delivery_date');
        document.querySelector("input[name='attributes[delivery_run]']").value = getCookie('delivery_run');
        document.querySelector("input[name='attributes[picking_store]']").value = getCookie('picking_store');
        document.querySelector("input[name='attributes[courier]']").value = getCookie('delivery_courier');
        document.querySelector("input[name='attributes[unique_window]']").value = getCookie('delivery_unique_window');
        document.querySelector("input[name='attributes[delivery_type]']").value = getCookie('delivery_type');
        document.querySelector("input[name='attributes[delivery_cc_store]']").value = getCookie('delivery_cc_store');
        document.querySelector("input[name='attributes[postcode]']").value = getCookie('postcode');
        document.querySelector("input[name='attributes[local_delivery_request]']").value = getCookie('delivery_time');
        
        // Show delivery reservation details.
        let deliveryDate = new Date(getCookie('delivery_date'));
        let formattedDeliveryDate = deliveryDate.toLocaleDateString('en-AU', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
        document.getElementById("delivery_date_text").innerText = formattedDeliveryDate;
        document.getElementById("delivery_type_text").innerText = getCookie('delivery_type_long');
        document.getElementById("delivery_time_text").innerText = getCookie('delivery_time_short');
        document.getElementById("delivery_cart_table").style.display = '';

        // Show calculate delivery charge button.                    
        document.querySelectorAll(".calc-delivery-charge").forEach(element => element.style.display = '');
    } else {
        // Show please reserve delivery time msg.
        document.getElementById("reserve_delivery_msg").style.display = '';
        document.getElementById("delivery_cart_table").style.display = 'none';
    }
}